import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

export function mapDeviceStatusToTranslocoKey(deviceStatus: DeviceStatus | undefined): string {
	switch (deviceStatus) {
		case DeviceStatus.Online:
			return 'common.network.online';
		case DeviceStatus.Offline:
			return 'common.network.offline';
		case DeviceStatus.Error:
			return 'common.network.error';
		case DeviceStatus.Discovered:
			return 'common.network.discovering';
		case undefined:
			return '';
	}
}
